import { Box, Text, DataTable, Chart, Spinner, Tag, Stack } from "grommet";
import { useState } from "react";

export interface TableProps {
  data: any[];
  progress: string;
}

const clipEncoding = function (number: number, min: number, max: number) {
  return Math.max(min, Math.min(number, max));
};

const thumbColors = [
  "#000094",
  "#0000b8",
  "#0000db",
  "#0000ff",
  "#3333ff",
  "#6666ff",
  "#9999ff",
  "#ccccff",
  "#ffffff",
  "#ffcccc",
  "#ff9999",
  "#ff6666",
  "#ff3333",
  "#ff0000",
  "#e60000",
  "#cc0000",
  "#b20000",
];

const chartColors = thumbColors.map((hex: string, index: number) => ({ color: hex, value: (index / 16) * 8 - 4 }));

export function Table({ data, progress }: TableProps): React.ReactElement {
  const columns = [
    {
      property: "ID",
      header: <Text>ID</Text>,
      primary: true,
    },
    {
      property: "Date",
      header: <Text>Date</Text>,
      primary: false,
    },
    {
      property: "Time",
      header: <Text>Time</Text>,
      primary: false,
    },
    {
      property: "Encoding",
      header: <Text>Encoding</Text>,
      render: (row: any) => {
        return (
          <Chart
            type="bar"
            values={row.Encoding.map((item: number, index: number) => ({
              value: [index, item],
              label: "factor_".concat(String(index + 1)),
              color: thumbColors[Math.round(clipEncoding(item, -4, 4) * 2) + 8],
            }))}
            round
            thickness="xsmall"
            size={{ height: "xsmall" }}
            bounds={[
              [0, 32],
              [-3, 3],
            ]}
            id={row.ID.concat(row.Date).concat(row.Time)}
          />
        );
      },
    },
    {
      property: "Probability",
      header: <Text>Probability</Text>,
      render: (row: any) => <Text>{row.Probability && String(Math.round(row.Probability * 100)).concat("%")}</Text>,
      primary: false,
    },
  ];

  return (
    <Box overflow="scroll" fill>
      {data.length >= 0 && (
        <DataTable
          sortable
          data={data}
          columns={columns}
          placeholder={
            progress !== "show" && (
              <Box
                align="center"
                justify="center"
                direction="row"
                pad="large"
                gap="small"
                background={{ color: "background-front", opacity: "strong" }}
              >
                {progress === "Processing..." && <Spinner />}
                <Text
                  weight="bold"
                  color={progress === "Invalid file uploaded" || progress === "Too many files uploaded (max 500)" ? "red" : "brand"}
                >
                  {progress}
                </Text>
              </Box>
            )
          }
          pin
        />
      )}
    </Box>
  );
}
